import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faRepeat, faTimes } from '@fortawesome/free-solid-svg-icons';

import { getContent, getErrorMessage } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import { CheckPermissionComponent } from '../../../util/permission';
import { SETTING_JOB_PROCESS_VIEW } from '../../../constants/menuPermissionConstant';
import API_SETTINGS from '../../../api/apiSettings';
import IconOpenedEye from '../../../assets/icons/IconOpenedEye';
import Dropdown from '../../../components/Common/Dropdown';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import TableNexcare from '../../../components/Table/TableNexcare';

class JobProcess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columnsMonitoring: [
                {
                    title: "ID Proses",
                    dataIndex: "job_id",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    width: "w-3/12",
                    render: (data) => `${data}`,
                },
                {
                    title: "Nama",
                    dataIndex: "name",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    width: "w-3/12",
                    render: (data) => `${data}`,
                },
                {
                    title: "Group",
                    dataIndex: "group",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Tipe",
                    dataIndex: "type",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Perkembangan",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => <>{data.counter}/{data.total}</>,
                },
                {
                    title: "Status",
                    dataIndex: "status",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Durasi",
                    dataIndex: "duration",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => (
                        <div className="flex">
                            <CheckPermissionComponent permissionConstant={[SETTING_JOB_PROCESS_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <div className="cursor-pointer" id="btndetailjobprocess" onClick={() => this.handleDetail(data)}><IconOpenedEye /></div>
                            </CheckPermissionComponent>
                        </div>
                    ),
                },
            ],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            jobProcess: {
                orderBy: [],
                orderSelected: '',
                orderType: '',
                searchBy: [],
                status: [],
                statusSelected: '',
                searchType: '',
                data: [],
                order: '',
                filter: '',
                detail: {},
                reset: false
            },
            searchKeyword: '',
            showDetail: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getInitiateJobProcess = () => {
        API_SETTINGS.getInitiateJobProcess(this.state.jobProcess.filter, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        jobProcess: {
                            ...this.state.jobProcess,
                            orderBy: getContent(res).valid_order_by,
                            searchBy: getContent(res).valid_search_by,
                            status: getContent(res).enum_data.status,
                        },
                        pagination: {
                            ...this.state.pagination,
                            total: getContent(res).count_data
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getJobProcess = () => {
        API_SETTINGS.getJobProcess(this.state.pagination.current, this.state.pagination.pageSize, this.state.jobProcess.order, this.state.jobProcess.filter, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        jobProcess: {
                            ...this.state.jobProcess,
                            data: getContent(res)
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getJobProcessDetail = id => {
        API_SETTINGS.getJobProcessDetail(id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        jobProcess: {
                            ...this.state.jobProcess,
                            detail: getContent(res)
                        },
                        showDetail: true
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                loading: true,
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                this.getInitiateJobProcess();
                this.getJobProcess();
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                loading: true,
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                this.getInitiateJobProcess();
                this.getJobProcess();
            }
        );
    }

    handleSorter = sorter => {
        this.setState(
            {
                loading: true,
                filter: sorter
            },
            () => {
                this.getInitiateJobProcess();
                this.getJobProcess();
            }
        );
    }

    handleChangeOrderBy = async order => {
        await this.setState({
            jobProcess: {
                ...this.state.jobProcess,
                orderSelected: order.value
            }
        })

        this.getInitiateJobProcess();
        this.getJobProcess();
    }

    handleOrderType = async type => {
        await this.setState({
            jobProcess: {
                ...this.state.jobProcess,
                orderType: type,
                order: this.state.jobProcess.orderSelected + ' ' + type
            }
        })

        this.getJobProcess();
    }

    handleChangeSearchBy = type => {
        this.setState({
            jobProcess: {
                ...this.state.jobProcess,
                searchType: type.value
            }
        })

        if (type === 'job_id') {
            this.setState({
                jobProcess: {
                    ...this.state.jobProcess,
                    statusSelected: ''
                }
            })
        }

        if (type === 'status') {
            this.setState({
                searchKeyword: ''
            })
        }
    }

    handleChangeStatus = status => {
        this.setState({
            jobProcess: {
                ...this.state.jobProcess,
                statusSelected: status.value
            }
        })
    }

    handleResetJobProcess = () => {
        this.setState({
            jobProcess: {
                ...this.state.jobProcess,
                reset: false
            }
        })
    }

    handleResetSearch = async () => {
        await this.setState({
            jobProcess: {
                ...this.state.jobProcess,
                searchType: '',
                statusSelected: '',
                filter: '',
                reset: true
            },
            searchKeyword: ''
        })

        this.getInitiateJobProcess()
        this.getJobProcess()
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSearch = async () => {
        let filter = '';
        if (this.state.searchKeyword !== '') {
            filter = `${this.state.jobProcess.searchType} like ${this.state.searchKeyword}`
        }
        if (this.state.jobProcess.statusSelected !== '') {
            filter = `${this.state.jobProcess.searchType} eq ${this.state.jobProcess.statusSelected}`
        }

        await this.setState({
            jobProcess: {
                ...this.state.jobProcess,
                filter: filter
            }
        })

        this.getInitiateJobProcess()
        this.getJobProcess()
    }

    handleDetail = data => {
        this.getJobProcessDetail(data.job_id)
    }

    handleDownload = id => {
        API_SETTINGS.getJobProcessDownload(id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let link = document.createElement("a");
                    link.href = window.URL.createObjectURL(new Blob([res.data], { type: "application/octet-stream" }));
                    link.download = res.headers && res.headers["content-disposition"].split("filename=")[1].split(";")[0];
                    document.body.appendChild(link);
                    link.click();
                    setTimeout(function () {
                        window.URL.revokeObjectURL(link);
                    }, 150);
                }
            }).catch(err => {
                this.setState({ errorMessage: getErrorMessage(err) })
                this.setState({ showErrorAlertResponse: true })
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getInitiateJobProcess();
        this.getJobProcess();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[SETTING_JOB_PROCESS_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="flex text-gray-600 overflow-auto calculate-layout">
                    <div className="w-full bg-white rounded-lg p-5 relative">
                        <div className="border-b-2 border-gray flex pb-5 mb-5">
                            <div className="w-1/3">
                                <p className="text-darkblue font-bold mb-5">Pemantauan</p>
                                <div className="mb-5 ml-0.5">
                                    <label>Urutkan</label>
                                    <Dropdown
                                        id="ddlorderby"
                                        placeholder="Pilih Urutkan"
                                        handleChange={this.handleChangeOrderBy}
                                        data={this.state.jobProcess.orderBy.map(data => ({ value: data, label: data }))}
                                    />
                                </div>
                            </div>
                            <div className="mt-16 flex">
                                <div className="bg-lightblue h-10 w-10 rounded text-white flex justify-center items-center mt-1 ml-2 cursor-pointer" id="btnorderasc" onClick={() => this.handleOrderType('ASC')}>
                                    <FontAwesomeIcon icon={faChevronUp} />
                                </div>
                                <div className="bg-lightblue h-10 w-10 rounded text-white flex justify-center items-center mt-1 ml-1 cursor-pointer" id="btnorderdesc" onClick={() => this.handleOrderType('DESC')}>
                                    <FontAwesomeIcon icon={faChevronDown} />
                                </div>
                            </div>
                        </div>
                        <div className="border-b-2 border-gray flex pb-5 mb-5">
                            <div className="w-1/3">
                                <div className="mb-5 ml-0.5">
                                    <label>Cari Berdasarkan</label>
                                    <Dropdown
                                        id="ddlsearchby"
                                        placeholder="Pilih Pencarian"
                                        handleChange={this.handleChangeSearchBy}
                                        data={this.state.jobProcess.searchBy.map(data => ({ value: data, label: data }))}
                                        reset={this.state.jobProcess.reset}
                                        handleReset={this.handleResetJobProcess}
                                    />
                                </div>
                            </div>
                            <div className="w-1/3 px-2">
                                {
                                    this.state.jobProcess.searchType === 'status'
                                        ? <div className="mb-5">
                                            <label>Status</label>
                                            <Dropdown
                                                id="ddlstatus"
                                                placeholder="Pilih Status"
                                                handleChange={this.handleChangeStatus}
                                                data={this.state.jobProcess.status.map(data => ({ value: data, label: data }))}
                                                reset={this.state.jobProcess.reset}
                                                handleReset={this.handleResetJobProcess}
                                            />
                                        </div>
                                        : <div className="mb-5">
                                            <label>Kata Kunci</label>
                                            <input type="text" id="tslkeywordmonitoring" className="form-control" placeholder="Tulis Kata Kunci" name="searchKeyword" value={this.state.searchKeyword} onChange={this.handleChange} />
                                        </div>
                                }
                            </div>
                            <div className="w-1/3 mt-5">
                                <div className="mb-5 flex">
                                    <div className="bg-lightblue h-10 w-10 rounded text-white flex justify-center items-center mt-1 cursor-pointer" id="btnreload" onClick={() => window.location.reload()}>
                                        <FontAwesomeIcon icon={faRepeat} />
                                    </div>
                                    <button type="button" id="btnreset" className="h-10 border border-darkblue text-darkblue rounded px-5 mt-1 ml-1" onClick={() => this.handleResetSearch()}>Atur Ulang</button>
                                    <button type="button" id="btnsearch" className="h-10 bg-darkblue text-white rounded px-5 mt-1 ml-1" onClick={() => this.handleSearch()}>Cari</button>
                                </div>
                            </div>
                        </div>
                        {/* Table Monitoring Job Process */}
                        <TableNexcare
                            column={this.state.columnsMonitoring}
                            dataTable={this.state.jobProcess.data}
                            pagination={this.state.pagination}
                            onPage={this.handleSelectedPage}
                            onPageSize={this.handleSelectedPageSize}
                            onSorter={this.handleSorter}
                            halfBodyHeight
                        />
                    </div>
                    <div className={this.state.showDetail ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 w-2/5 max-h-2/3 relative">
                                <div className="header flex justify-between">
                                    <div></div>
                                    <FontAwesomeIcon icon={faTimes} className="cursor-pointer" id="btnclosedetailjobprocess" onClick={() => this.setState({ showDetail: false })} />
                                </div>
                                <p className="font-bold text-lg mb-5">Rincian Proses Latar Belakang</p>
                                <div className="flex items-center">
                                    <div className="w-1/2">
                                        <p>ID Proses</p>
                                        <p>Nama</p>
                                        <p>Grup</p>
                                        <p>Tipe</p>
                                        <p>Status</p>
                                        <p>Durasi</p>
                                        <p>Perkembangan</p>
                                        <p>Dibuat Tanggal</p>
                                        <p>Diperbaharui Tanggal</p>
                                        <p>Anak Latar Belakang Proses</p>
                                    </div>
                                    <div className="w-1/2">
                                        <p>: {this.state.jobProcess.detail.job_id}</p>
                                        <p>: {this.state.jobProcess.detail.name}</p>
                                        <p>: {this.state.jobProcess.detail.group}</p>
                                        <p>: {this.state.jobProcess.detail.type}</p>
                                        <p>: {this.state.jobProcess.detail.status}</p>
                                        <p>: {this.state.jobProcess.detail.duration}</p>
                                        <p>: {this.state.jobProcess.detail.counter}/{this.state.jobProcess.detail.total}</p>
                                        <p>: {moment.utc(this.state.jobProcess.detail.created_at).format('DD/MM/YYYY HH:mm')}</p>
                                        <p>: {moment.utc(this.state.jobProcess.detail.updated_at).format('DD/MM/YYYY HH:mm')}</p>
                                        <p>: {this.state.jobProcess.detail.child_job_process === null ? '-' : this.state.jobProcess.detail.child_job_process}</p>
                                    </div>
                                </div>
                                <CheckPermissionComponent permissionConstant={[SETTING_JOB_PROCESS_VIEW]} userPermission={this.props.userDetail.permissions}>
                                    <p className="text-lightblue cursor-pointer mt-5" id="btndownloadjobprocess" onClick={() => this.handleDownload(this.state.jobProcess.detail.job_id)}>Unduh di sini</p>
                                </CheckPermissionComponent>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(JobProcess);